var e=()=>navigator?.languages||[];export{e as navigatorDetector};
